import { connect } from 'react-redux'
import {
    getLaunchDelay,
    getLaunchDelayText,
    getSecondsText,
    setLaunchDelay,
    increaseCounter,
} from '../../../../data'
import LaunchDelay from './component'

function mapStateToProps(state) {
    return {
        label: getLaunchDelayText(state),
        seconds: getSecondsText(state),
        value: getLaunchDelay(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        update: (delay) => {
            dispatch(setLaunchDelay(delay))
            dispatch(increaseCounter())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LaunchDelay)



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/LaunchDelay/index.js